import { useFormContext } from 'react-hook-form';
import { LwFormTime } from 'redesign';
import { Grid } from '@mui/material';
import { EndTimeFormContext, StartTimeFormContext } from './time-inputs.types';

export const TimeInputs = ({ disabled }: { disabled: boolean }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <StartTimeElement disabled={disabled} />
      </Grid>
      <Grid item xs={6}>
        <EndTimeElement disabled={disabled} />
      </Grid>
    </Grid>
  );
};

const StartTimeElement = ({ disabled }: { disabled: boolean }) => {
  const { control } = useFormContext<StartTimeFormContext>();
  return (
    <LwFormTime
      name="startTime"
      label="Van"
      control={control}
      data-testid="start-time"
      disabled={disabled}
    />
  );
};

const EndTimeElement = ({ disabled }: { disabled: boolean }) => {
  const { control } = useFormContext<EndTimeFormContext>();

  return (
    <LwFormTime
      name="endTime"
      label="Tot"
      control={control}
      data-testid="end-time"
      disabled={disabled}
    />
  );
};
